import { HttpClient } from '@angular/common/http';
import { computed, Inject, Injectable, signal } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { map, Observable, tap } from 'rxjs';
import { IUserKycStepModel } from '../models/user-kyc-step.model';

@Injectable({
  providedIn: 'root'
})
export class KycVerificationService {


  private kycStepSource = signal<IUserKycStepModel>({} as IUserKycStepModel);
  public kycStep$ = computed(() => { return this.kycStepSource() });

  public hasFetchedKycStep: boolean = false;
  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private http: HttpClient
  ) { }

  getUserKycStep(): void {
    this.getUserKycStepForResolver().subscribe();
  }

  getUserKycStepForResolver(): Observable<any> {
    return this.http.get(`${this.appConfig.apiEndpoint}/new-core/kyc/step`)
      .pipe(
        map((res) => res['data']),
        tap(res => {
          this.updateKycStep(res);
          this.hasFetchedKycStep = true;
        }));
  }


  updateKycStep(value: IUserKycStepModel): void {
    localStorage.setItem('kycStep', JSON.stringify(value));
    this.kycStepSource.set(value);
  }

  getNeedVerifyItems(): boolean {
    const kycStepString = localStorage.getItem('kycStep');
    if (!kycStepString) {
      return true; // If nothing exists, do not allow entry (could mean not verified or not logged in)
    }

    try {
      const kycStep: IUserKycStepModel = JSON.parse(kycStepString);
      return !kycStep.isVerified;
    } catch (e) {
      console.error('Invalid kycStep in localStorage:', e);
      return true; // Error in parsing => fallback to conservative behavior
    }
  }

}
